export enum LabelType {
  Static01 = 'static01',
  Static02 = 'static02',
  Static04 = 'static04',
  Static05 = 'static05',
  Static06 = 'static06',
  DarkLight01 = 'darklight01',
  DarkLight02 = 'darklight02',
  DarkLight03 = 'darklight03',
}
